var _title, _desc, _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLike = function SvgLike(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "like_Group 9")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .main { stroke: #A8A8A7 }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LIbraway_loggato",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ricetta_new",
    transform: "translate(-815.000000, -2261.000000)",
    className: "main",
    strokeWidth: 1.938
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(807.000000, 2255.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(9.406800, 7.526222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.23041096,9.92922033 L3.86778082,9.92922033 C4.54093151,9.92922033 5.08684932,10.4755125 5.08684932,11.1513327 L5.08684932,24.2509731 C5.08684932,24.7893552 4.65139726,25.2249057 4.11484932,25.2249057 L1.08493151,25.2249057 C0.485753425,25.2249057 -8.97060204e-14,24.7384338 -8.97060204e-14,24.1377597 L-8.97060204e-14,11.1622091 C-8.97060204e-14,10.4804563 0.550849315,9.92922033 1.23041096,9.92922033 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2593808,5.35228101 C13.6244219,3.98482033 13.8512712,1.61920236 13.8991068,0.830663029 C13.9000932,0.818797861 13.9040384,0.797539434 13.9104493,0.768865277 C14.033737,0.198842805 14.6427781,-0.15661787 15.179326,0.0683259507 C16.1493534,0.474213591 16.8308877,1.4338091 16.8308877,2.55309 L16.8308877,8.61767427 C16.8313808,8.61816865 16.831874,8.61866303 16.8323671,8.61965179 L22.1421205,8.61965179 C23.8898466,8.61816865 25.3071616,10.0385282 25.3086411,11.7896293 L25.3086411,11.7916068 L25.3086411,22.0505282 C25.3086411,23.8036068 23.8908329,25.2249552 22.1421205,25.2249552 L8.34672329,25.2249552 C7.62623014,25.223472 7.04283288,24.6386181 7.04332571,23.9168203 L7.04332571,12.14509 C7.04628493,11.4257642 10.6951068,6.92046078 12.2593808,5.35228101 Z",
    id: "Stroke-3"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLike, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/like.6e692517.svg";
export { ForwardRef as ReactComponent };